import React, { useState, useEffect } from 'react';
import { addRemark } from '../../../services/api-services';
import { toastEmitter } from '../../../utills/utilities';

const Remark = ({
  selectedCompanyId,
  selectedCampaignId,
  type,
  graphName,
  initialRemark = '',
  remarkId = '', 
  isAttempt = 0,
  setRemarkprops,
  setRemarkIdProps,
  onCloseModal,
}) => {
  const [remark, setRemark] = useState(initialRemark);
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  // Detect edit mode
  useEffect(() => {
    setRemark(initialRemark);
    setIsEditMode(!!remarkId);
  }, [initialRemark, remarkId]);

  // 🧠 Add or Update Remark
  const handleSaveRemark = async () => {
    if (!remark.trim()) {
      toastEmitter('error', 'Please enter a remark.');
      return;
    }

    const payload = {
      id: remarkId || null, // 👈 ensure correct ID sent
      remark,
      graphName,
      companyId: selectedCompanyId,
      campaignId: selectedCampaignId,
      type,
      isAttempt,
    };

    try {
      setLoading(true);
      const response = await addRemark(payload);

      if (response?.data?.responseCode === 200) {
        const successMsg =
          remarkId && remarkId !== ''
            ? 'Remark updated successfully.'
            : 'Remark added successfully.';
        const resBody = response?.data?.responseBody || {};

        toastEmitter('success', response?.data?.message || successMsg);

        // Update parent remark state
        setRemarkprops?.(resBody?.remark || remark);
        setRemarkIdProps?.(resBody?.id || remarkId);

        // Switch to edit mode
        setIsEditMode(true);

        //  Close modal after short delay
        setTimeout(() => {
          handleCloseModal();
        }, 400);
      } else {
        toastEmitter('error', response?.data?.message || 'Error saving remark.');
      }
    } catch (err) {
      toastEmitter('error', 'Something went wrong while processing your request.');
    } finally {
      setLoading(false);
    }
  };

  // Proper Modal Close + Backdrop Cleanup
  const handleCloseModal = () => {
    onCloseModal?.();

    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((b) => b.remove());
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
  };

  return (
    <div className="remark-section">
      <label className="form-label fw-semibold">Remark</label>
      <textarea
        className="form-control mb-3"
        rows="3"
        placeholder="Add remark"
        maxLength={200}
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
      ></textarea>

      <div className="text-end">
        <button
          className="btn btn-secondary me-2"
          onClick={handleCloseModal}
          disabled={loading}
        >
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={handleSaveRemark}
          disabled={loading}
        >
          {loading
            ? 'Saving...'
            : isEditMode
            ? 'Update Remark'
            : 'Add Remark'}
        </button>
      </div>
    </div>
  );
};

export default Remark;
